/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Select_Set_PromptInputs */

const en_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a Tag Set from the menu on the left`)
};

const fr_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un ensemble de tags dans le menu de gauche`)
};

const de_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie links im Menü ein Tag-Set aus.`)
};

const it_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un set di tag dal menu a sinistra`)
};

const ru_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите набор тегов из меню слева.`)
};

const es_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un conjunto de etiquetas del menú de la izquierda`)
};

const zh_cn2_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从左侧菜单中选择一个标签集。`)
};

const ja_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左側のメニューからタグセットを選択してください`)
};

const hi_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया बाईं ओर के मेनू से एक टैग सेट चुनें।`)
};

const pt_pt2_tags_manager_select_set_prompt = /** @type {(inputs: Tags_Manager_Select_Set_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um conjunto de etiquetas no menu à esquerda.`)
};

/**
* | output |
* | --- |
* | "Please select a Tag Set from the menu on the left" |
*
* @param {Tags_Manager_Select_Set_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_select_set_prompt = /** @type {((inputs?: Tags_Manager_Select_Set_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Select_Set_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_select_set_prompt(inputs)
	if (locale === "de") return de_tags_manager_select_set_prompt(inputs)
	if (locale === "it") return it_tags_manager_select_set_prompt(inputs)
	if (locale === "ru") return ru_tags_manager_select_set_prompt(inputs)
	if (locale === "es") return es_tags_manager_select_set_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_select_set_prompt(inputs)
	if (locale === "ja") return ja_tags_manager_select_set_prompt(inputs)
	if (locale === "hi") return hi_tags_manager_select_set_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_select_set_prompt(inputs)
	return en_tags_manager_select_set_prompt(inputs)
});